import { render, staticRenderFns } from "./Logocard.vue?vue&type=template&id=0328bc18&scoped=true&"
import script from "./Logocard.vue?vue&type=script&lang=js&"
export * from "./Logocard.vue?vue&type=script&lang=js&"
import style0 from "./Logocard.vue?vue&type=style&index=0&id=0328bc18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328bc18",
  null
  
)

export default component.exports